import { getVersionUpgrade, VersionUpgrade } from '@uniswap/token-lists'
import { useConnection } from 'hooks/useConnection'
import useInterval from 'lib/hooks/useInterval'
import { useEffect } from 'react'
import { useAppDispatch } from 'state/hooks'
import { useAllLists, useForceRefreshAllTokenLists } from 'state/lists/hooks'

// import { isCelo } from '../../constants/tokens'
import { useFetchListCallback } from '../../hooks/useFetchListCallback'
import { acceptListUpdate } from './actions'

export default function Updater(): null {
  const { wagmiPublicClient } = useConnection()
  const dispatch = useAppDispatch()

  // get all loaded lists, and the active urls
  const lists = useAllLists()
  // const activeListUrls = useActiveListUrls()

  const fetchList = useFetchListCallback()
  const forceRefreshAllTokenLists = useForceRefreshAllTokenLists()
  // fetch all lists every 10 minutes, but only after we initialize wagmi client
  useInterval(forceRefreshAllTokenLists, wagmiPublicClient ? 1000 * 60 * 10 : null)

  // whenever a list is not loaded and not loading, try again to load it
  useEffect(() => {
    Object.keys(lists).forEach((listUrl) => {
      const list = lists[listUrl]
      if (!list.current && !list.loadingRequestId && !list.error) {
        fetchList(listUrl).catch((error) => console.debug('list added fetching error', error))
      }
    })
  }, [dispatch, fetchList, lists])

  // automatically update lists if versions are minor/patch
  useEffect(() => {
    Object.keys(lists).forEach((listUrl) => {
      const list = lists[listUrl]
      if (list.current && list.pendingUpdate) {
        const bump = getVersionUpgrade(list.current.version, list.pendingUpdate.version)
        switch (bump) {
          case VersionUpgrade.NONE:
            throw new Error('unexpected no version bump')
          case VersionUpgrade.PATCH:
          case VersionUpgrade.MINOR:
          case VersionUpgrade.MAJOR:
            dispatch(acceptListUpdate(listUrl))
        }
      }
    })
  }, [dispatch, lists])

  return null
}
